/**
 * Shared constants for timesheet utilities
 */

/**
 * Constants for time calculations
 */
export const TIME_CONSTANTS = {
  SECONDS_PER_MINUTE: 60,
  SECONDS_PER_HOUR: 3600,
  SECONDS_PER_DAY: 86400,
  MINUTES_PER_HOUR: 60,
  MINUTES_PER_DAY: 1440,
  HOURS_PER_DAY: 24,
};

/**
 * Duration format styles
 */
export const DURATION_STYLES = {
  SHORT: "short",
  LONG: "long",
};

/**
 * Fallback premium multiplier for holiday-worked hours, used only when the backend
 * doesn't supply `workedHoursMultiplier`. The backend (People::Shifts::PayPolicy)
 * is the source of truth — this guards against a missing value, it does not define
 * the rate. Mirrors the current PayPolicy holiday multiple (1.5x base).
 */
export const HOLIDAY_WORKED_RATE_MULTIPLIER_FALLBACK = 1.5;

/**
 * Defaults for a newly added break (12:00-12:30 PM, or an hour into an overnight shift)
 */
export const BREAK_DEFAULTS = {
  START: TIME_CONSTANTS.SECONDS_PER_HOUR * 12,
  DURATION: TIME_CONSTANTS.SECONDS_PER_MINUTE * 30,
  OFFSET_FROM_SHIFT_START: TIME_CONSTANTS.SECONDS_PER_HOUR,
};

/**
 * New shift template with default values (9 AM - 5 PM)
 */
export const NEW_SHIFT = {
  id: "", // Empty ID indicates new shift
  startTime: 9 * 3600, // 9:00 AM in seconds since midnight
  endTime: 17 * 3600, // 5:00 PM in seconds since midnight
  breaks: [],
  projectToken: undefined,
  projectName: undefined,
  assignmentPayRateId: undefined,
  notes: undefined,
  referenceNumber: undefined,
  hoursWorkedEmployee: undefined,
  hoursWorkedEmployer: undefined,
  notesEmployee: undefined,
  notesEmployer: undefined,
  hoursBreakEmployee: undefined,
  isSubmitted: false,
  isApproved: false,
  isBackshift: false,
};
